import { addCursorLoader, api, removeCursorLoader, url } from 'dmui_components'

function _formatValidationErrors(detail) {
	return detail.map((error) => ({
		path: `Row ${error.path.split('.')[0]} `,
		message: `${error.path.split('.')[1]} ${error.message}`
	}))
}

export class APIErrors extends Error {
	constructor(detail = []) {
		super('API request failed')
		this.detail = Array.isArray(detail) ? _formatValidationErrors(detail) : [{ path: 'API error:', message: detail }]
	}
}

class ReportIRORepository {
	async getReportIROs(report_id) {
		try {
			addCursorLoader()
			return await api(url`/csrd_iro/${report_id}`)
		} catch (e) {
			console.error('Error fetching report IROs', e)
		} finally {
			removeCursorLoader()
		}
	}

	async getCsrdIroList(modifiers = {}) {
		const stringParams = JSON.stringify(modifiers)
		return await api(url`/csrd_iro?body_string=${stringParams}`)
	}

	async updateCsrdIroStatus(report) {
		await api(url`csrd_iro/${report.report_id}/status`, {
			method: 'PUT',
			body: { status: report.status }
		})
	}

	async postIroList(iroList) {
		try {
			await api('/csrd_iro', {
				method: 'POST',
				body: iroList
			})
		} catch (e) {
			throw new APIErrors(e.detail || 'Unexpected error occurred while uploading the file')
		}
	}
	async deleteOneIro(id) {
		await api(url`/csrd_iro/${id}`, {
			method: 'DELETE'
		})
	}

	async deleteOneEntitySpecificIro(id) {
		await api(url`/csrd_iro/entity_specific/${id}`, {
			method: 'DELETE'
		})
	}
}

export default new ReportIRORepository()
